import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getEventsData = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/events', METHOD_TYPES.GET, data, callback);
};

export const getEventDetails = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/event', METHOD_TYPES.GET, data, callback);
};

export const createEvent = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/event', METHOD_TYPES.POST, data, callback);
};

export const updateEvent = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/event', METHOD_TYPES.PUT, data, callback);
};

export const deleteEvent = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/event', METHOD_TYPES.DELETE, data, callback);
};

export const getEventHistogram = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/analytics/eventsAnalytics', METHOD_TYPES.GET, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/event_details/api.js